import {
  excludeOptions,
  useGetProjectFolderDetailsQuery
} from '../../../react-query/project/query/use-get-project-folder-details-query'
import { useUpdateProjectFolderMutation } from '../../../react-query/project/mutation/use-update-project-folder-mutation'
import RenameModal from '../../../components/rename-modal'
import { useHistory, useParams } from 'react-router-dom'
import { useProjectMenuListViewControl } from '../../../hooks/use-project-menu-list-view-control'
import { useIntl } from 'react-intl'
import { useState } from 'react'
import { projectMenuApiErrorCodeOptions } from '../constants'
import { useSnackbar } from '../../../components/stories/molecules/snackbar/component/snackbar-hook'
import { snackbarVariantOptions } from '../../../components/stories/molecules/snackbar/constants'

const ProjectRenameFolderModalWrapper = () => {
  const { formatMessage } = useIntl()

  const { addSnackbar } = useSnackbar()

  const [titleHintMessage, setTitleHintMessage] = useState(null)

  const history = useHistory()
  const { id } = useParams()
  const { viewType, tab } = useProjectMenuListViewControl()

  const { data, isLoading } = useGetProjectFolderDetailsQuery(id, [
    excludeOptions.PROJECTS,
    excludeOptions.SUB_FOLDERS
  ])

  const showSnackbarSuccess = () => {
    addSnackbar({
      message: formatMessage({ id: 'folder_renamed' }),
      snackbarType: snackbarVariantOptions.SUCCESS,
      hideCloseButton: true
    })
  }

  const handleClosePopup = () => {
    history.push(`/project?view=${viewType}&tab=${tab}`)
  }

  const handleUpdateProjectFolderSuccess = () => {
    showSnackbarSuccess()
    handleClosePopup()
  }

  const handleUpdateProjectFolderError = (error) => {
    if (
      error &&
      error.response?.data?.status ===
        projectMenuApiErrorCodeOptions.FOLDER_NAME_IS_NOT_AVAILABLE
    ) {
      setTitleHintMessage(
        formatMessage({ id: 'projectMenu_folder_with_this_name_aready_exists' })
      )
    }
  }

  const { mutate, isPending } = useUpdateProjectFolderMutation({
    onSuccess: handleUpdateProjectFolderSuccess,
    onError: handleUpdateProjectFolderError
  })

  const isLoadingModal = isPending || isLoading

  const handleUpdate = (name) => {
    setTitleHintMessage(null)
    mutate({
      folderId: id,
      body: { name }
    })
  }

  const oldName = data?.name ?? ''

  return (
    <RenameModal
      headerTitle={formatMessage({ id: 'rename_folder' })}
      handleRename={handleUpdate}
      onClose={handleClosePopup}
      error={titleHintMessage}
      isLoading={isLoadingModal}
      oldName={oldName}
      isOpen
    />
  )
}

export default ProjectRenameFolderModalWrapper
